import OptionsPanel from "./OptionsPanel.js"

export default class FontOpacity extends OptionsPanel {

  constructor(props, context) {
    super(props, context)

    this.state.title = "Font Opacity" // TODO: This needs to be localized
    this.setting = "fontOpacity"
    this.listOptions = props.labels[this.setting]
    this.select()
  }

  static get contextTypes() {
    return super.contextTypes
  }


}
